import { buildActionFields } from './buildActionFields';
import { buildAliases } from './buildAliases';
import { buildCollaborationContextFields } from './buildCollaborationContextFields';
import { buildEventOverrides } from './buildEventOverrides';
import { buildGroups } from './buildGroups';
import { buildOrgFields } from './buildOrgFields';
import { buildProductFields } from './buildProductFields';
import { buildTenantFields } from './buildTenantFields';
import { buildUserFields } from './buildUserFields';
import { buildWorkspaceFields } from './buildWorkspaceFields';
import { extractProductOverrides } from './extractProductOverrides';
import {
	type BuiltActionEvent,
	type CollaborationContextInfo,
	type InteractionSession,
	type InternalProductInfoType,
} from './types';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function buildActionEvent(
	productInfo: InternalProductInfoType,
	tenantInfo: any,
	userInfo: any,
	event: any,
	actionEventType: any,
	tabId: any,
	sessionId: any,
	taskSessions: any,
	interactionSession: InteractionSession,
	orgInfo: any,
	pageLoadId: string,
	workspaceInfo: any,
	collaborationContextInfo: CollaborationContextInfo,
	aliases?: any,
	groups?: any,
): BuiltActionEvent {
	const productFields = buildProductFields(productInfo, extractProductOverrides(event));
	const tenantFields = buildTenantFields(tenantInfo);
	const orgFields = buildOrgFields(orgInfo);
	const workspaceFields = buildWorkspaceFields(workspaceInfo);
	const collaborationContextFields = buildCollaborationContextFields(collaborationContextInfo);
	const userFields = buildUserFields(userInfo);
	const actionFields = buildActionFields(event, actionEventType);
	return {
		...productFields,
		...tenantFields,
		...orgFields,
		...userFields,
		...actionFields,
		...buildEventOverrides(event),
		tabId,
		sessionId,
		taskSessions,
		interactionSession,
		pageLoadId,
		...workspaceFields,
		...collaborationContextFields,
		...buildAliases(aliases),
		...buildGroups(groups),
	};
}
